<template lang="pug">
.v-leasing-form-result-dropdown.dropdown-field.dropdown-field--arrow
	svg.dropdown-arrow(width="32", height="16", viewbox="0 0 32 16", fill="none", xmlns="http://www.w3.org/2000/svg", aria-hidden="true")
		path(fill-rule="evenodd", clip-rule="evenodd", d="M13.6286 1.96444C13.8848 0.850958 14.8574 0 16 0C17.1426 0 18.1152 0.85096 18.3714 1.96444C19.3548 6.23822 22.6268 16 32 16H0C9.37315 16 12.6452 6.23822 13.6286 1.96444Z", fill="#EFF2F9")
	.dropdown-field-container
		.v-leasing-form-result
			VueTab(:init-tab-index="resultInitTabIndex", background-color="white", select-color="dark-gray")
				template(v-for="(calculation, periodNumber, index) in calculations")
					template(:slot="`tab-head-${index}`") {{ periodNumber }} hó futamidővel ({{ periodNumber / 12 }} év)
					ul.v-leasing-form-result__items(v-if="!isSzechenyi", :slot="`tab-panel-${index}`")
						li.v-leasing-form-result__item(v-for="(result, index) in sortedCalculations(calculations[periodNumber])", :class="{ 'sf-card': isMobile }")
							.v-leasing-form-result__noresult(v-if="result.publicErrorMessage")
								VueFormNotification(type="error", :live-region="false")
									p {{ result.publicErrorMessage }}
							template(v-else)
								dl.v-leasing-form-result__deflist
									dt
										h5(:id="`v-leasing-title-${index}`") {{ setLeasingTitle(result) }}
										VueTooltip(placement="bottom")
											p(slot="content")
												template(v-if="result.interestMode === 'V'") A futamidő során a kamatok a Referencia Kamat (3 hónapos BUBOR) változásának függvényében módosulhatnak.
												template(v-else) A futamidő során a lízingdíj-részlet nagysága nem változik.
									dd(:id="`v-leasing-result-price-${index}`")
										| {{ result.instalment | currency('HUF') }} Ft/hó
									dt Teljes hiteldíjmutató (THM)
									dd {{ result.thm }}%
									dt Induló éves ügyleti kamat
									dd {{ result.publicRate }}%
									dt Teljes visszafizetett összeg
									dd {{ result.fullPrice | currency('HUF') }} Ft
								VueButton(type="button", :id="`v-leasing-result-cta-${index}`", button-type="primary", :aria-labelledby="`v-leasing-cta-${index} v-leasing-title-${index} v-leasing-price-${index}`", @click.prevent="openEmailCalculationModal($event, result)") Kérem az ajánlatot
								a.sf-link(href="#gepjarmu-lizing-kalk-eredmeny-kerdesem-van") Kérdésem van
						li.v-leasing-form-result__item(v-if="calculations[periodNumber].length === 1", :class="{ 'sf-card': isMobile }")
							.v-leasing-form-result__noresult
								p Fix kamatozású lízinget minimum 1 év, maximum 7 év futamidővel nyújtunk.

					template(v-else="", :slot="`tab-panel-${index}`")
						template(v-for="(result, index) in sortedCalculations(calculations[periodNumber])")
							.v-leasing-form-result__item(v-if="result.interestMode === 'F'", :class="{ 'sf-card': isMobile }")
								.v-leasing-form-result__noresult(v-if="result.publicErrorMessage")
									VueFormNotification(type="error", :live-region="false")
										p {{ result.publicErrorMessage }}
								template(v-else)
									dl.v-leasing-form-result__deflist
										dt
											h5(:id="`v-leasing-title-${index}`") {{ setLeasingTitle(result) }}
										dd(:id="`v-leasing-result-price-${index}`")
											| {{ result.instalment | currency('HUF') }} Ft/hó
										dt Ügyleti kamat
										dd {{ result.publicRate }}%
									VueButton(type="button", :id="`v-leasing-result-cta-${index}`", button-type="primary", :aria-labelledby="`v-leasing-cta-${index} v-leasing-title-${index} v-leasing-price-${index}`", @click.prevent="openEmailCalculationModal($event, result)") Kérem az ajánlatot
									a.sf-link(href="#gepjarmu-lizing-kalk-eredmeny-kerdesem-van") Kérdésem van
						.v-leasing-form-result__item(v-if="calculations[periodNumber].length === 1 && calculations[periodNumber][0].interestMode === 'V'", :class="{ 'sf-card': isMobile }")
							.v-leasing-form-result__noresult
								p Fix kamatozású lízinget minimum 1 év, maximum 7 év futamidővel nyújtunk.
	portal(to="modal-outlet")
		VueModal(modal-id="email-calculation-modal")
			template(slot="modal-column-wide")
				h3.sf-heading-2.page-subtitle(v-if="calculationVisible", slot="modal-header", ref="call-request-title", tabindex="-1") Hivatalos ajánlatot kérek
				CalculationEmail(:type="TYPES.VEHICLE", @change-calculation-visible="calculationVisible = $event")
					template(v-slot="{ email }")
						p A kalkuláció adatait elküldtük #[strong {{ email }}] e-mail-címre.
			template(slot="modal-column-narrow")
				template(v-if="calculationVisible")
					CalculationEmailResult
</template>
<script>
import VueTab from '@ui-common/vue-tab';
import VueTooltip from '@ui-common/vue-tooltip';
import VueButton from '@ui-common/vue-button';
import VueFormNotification from '@ui-common/vue-form-notification';
import { INTEREST_TYPES, DEBTOR_TYPES, LEASING_TYPE, CALCULATION_RETURN_CODES } from '../../constants';
import { TYPES } from '../../../calculation-email/constants';
import { isMobile } from '@ui-common/sf-js-utils';
import { mapState } from 'vuex';
export default {
	data: () => ({
		calculationVisible: true
	}),
	props: {
		calculations: {
			type: Object,
			required: true
		},
		periodNumber: {
			required: true
		},
		resultInitTabIndex: {
			required: true
		},
		financeTypes: {
			required: true
		}
	},
	watch: {
		calculations: {
			handler(val) {
				this.$nextTick(() => {
					this.$scrollTo(this.$el);
				});
			},
			immediate: true
		}
	},
	mixins: [isMobile],
	components: {
		VueTab,
		VueTooltip,
		VueButton,
		VueFormNotification
	},
	computed: {
		...mapState('calculation-email', ['debtorType', 'duration', 'financeType']),
		TYPES: () => TYPES,
		relevantCalculation() {
			return this.calculations && this.calculations[this.duration];
		},
		isSzechenyi() {
			return this.financeType == this.financeTypes?.[1]?.key;
		}
	},
	methods: {
		setLeasingTitle(result) {
			const leaseFeeText = this.isSzechenyi
				? result.leasingType == LEASING_TYPE.OPEN
					? 'Nettó induló lízingdíj'
					: 'Induló lízingdíj'
				: result.debtorType == DEBTOR_TYPES.PERSONAL || (result.debtorType != DEBTOR_TYPES.PERSONAL && result.leasingType == LEASING_TYPE.CLOSED)
				? 'Lízingdíj'
				: 'Nettó lízingdíj';
			const interestModeText = result.interestMode == 'F' ? INTEREST_TYPES.FIX : INTEREST_TYPES.VARIABLE;
			return this.isSzechenyi ? leaseFeeText : `${leaseFeeText} ${interestModeText} kamatozással`;
		},
		openEmailCalculationModal(e, result) {
			this.$store.dispatch('calculation-email/setLeasingTitle', this.setLeasingTitle(result));
			this.$store.dispatch('calculation-email/setLeasingType', result.leasingType);
			this.$store.dispatch('calculation-email/setInterestType', result.interestMode == 'F' ? INTEREST_TYPES.FIX : INTEREST_TYPES.VARIABLE);
			this.$store.dispatch('calculation-email/setFinancedPrice', result.financedPrice);
			const durationText = this.periodNumber.find(periodNumber => periodNumber.key == result.periodNumber).value;
			this.$store.dispatch('calculation-email/setDurationText', durationText);
			this.$store.dispatch('calculation-email/setInstalment', result.instalment);
			this.$store.dispatch('calculation-email/setRapplId', result.rapplId);
			this.$store.dispatch('calculation-email/setRnote', result.rnote);
			this.$openModal(e, 'email-calculation-modal');
			this.$hideModalHeader('email-calculation-modal');
			if (result.precalcInstalment) {
				this.$store.dispatch('calculation-email/setPrecalcInstalment', result.precalcInstalment);
			}
		},
		sendGtm() {
			const variableCalculation = this.relevantCalculation.find(
				calculation => calculation.interestMode == 'V' && calculation.returnCode == CALCULATION_RETURN_CODES.SUCCESS
			);
			const fixCalculation = this.relevantCalculation.find(
				calculation => calculation.interestMode == 'F' && calculation.returnCode == CALCULATION_RETURN_CODES.SUCCESS
			);
			this.$gtm.trackEvent({
				event: 'carLeasign',
				carLeasingFixValue: fixCalculation?.instalment,
				carLeasingVariableValue: variableCalculation?.instalment
			});
		},
		sortedCalculations(list) {
			const listClone = [...list];
			const sortedList = listClone.sort((a, b) => (a.interestMode > b.interestMode ? 1 : -1));
			return sortedList;
		}
	},
	created() {
		this.sendGtm();
	}
};
</script>
<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.v-leasing-form-result-dropdown {
	padding: 24px 8px 24px 8px;

	@include media('>=tablet') {
		margin-bottom: 48px;
		margin-top: 0;
		padding: 24px;
	}
}

.v-leasing-form-result__item {
	margin-bottom: 24px;
	position: relative;

	@include media('>=tablet') {
		margin: -16px;
	}

	@include media('>=desktop') {
		margin: -16px auto;
		width: 50%;
	}
}

ul.v-leasing-form-result__items {
	@include media('>=tablet') {
		display: flex;
		margin: 0 -16px;
	}
}

li.v-leasing-form-result__item {
	margin-bottom: 24px;
	position: relative;

	@include media('>=tablet') {
		margin: 0;
		padding: 0 32px;
		width: 50%;
	}

	&:nth-child(1) {
		@include media('>=tablet') {
			padding-left: 0;
		}
	}

	&:nth-child(2) {
		@include media('>=tablet') {
			padding-right: 0;
		}
	}
}

li.v-leasing-form-result__item:first-child::after {
	@include media('>=tablet') {
		background-color: $contentBg-gray-2;
		content: '';
		display: block;
		height: 100%;
		position: absolute;
		right: 0;
		top: 0;
		width: 1px;
	}
}

.v-leasing-form-result__deflist {
	display: block;
	position: relative;

	&:last-of-type {
		@include media('<tablet') {
			padding-top: 16px;
		}
	}
}

.v-leasing-form-result__deflist:nth-child(2)::after {
	background-color: $contentBg-gray-2;
	content: '';
	display: block;
	height: 1px;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}

.v-leasing-form-result__deflist dt {
	display: block;
	font-size: 14px;

	@include media('>=tablet') {
		display: inline-block;
		width: 60%;
	}
}
.v-leasing-form-result__deflist dd {
	display: block;
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 24px;

	@include media('>=tablet') {
		display: inline-block;
		text-align: right;
		vertical-align: top;
		width: 40%;
	}
}

.v-leasing-form-result__deflist:nth-child(2) dd:last-of-type {
	font-size: 16px;
}

.v-leasing-form-result h5,
.v-leasing-form-result__deflist .sf-tooltip {
	display: inline;
	font-size: 14px;
	margin-right: 3px;
	vertical-align: middle;
}

.v-leasing-form-result-dropdown.dropdown-field--arrow .dropdown-arrow {
	display: block;
	height: 16px;
	left: 120px;
	position: absolute;
	top: -16px;
	width: 32px;
	z-index: 1;

	@include media('>=tablet') {
		left: 164px;
	}

	@include media('>=desktop') {
		left: 188px;
	}

	@include media('>=desktop-lg') {
		left: 200px;
	}
}

.v-leasing-form-result__item .sf-btn {
	display: block;
	margin-bottom: 32px;

	@include media('>=tablet') {
		display: inline-block;
		margin-bottom: 0;
		margin-right: 8px;
	}
}

.v-leasing-form-result__item .sf-link {
	display: inline-block;

	@include media('>=desktop') {
		margin-top: 16px;
	}
}

.v-leasing-form-result__noresult {
	align-items: center;
	font-size: 16px;
	height: 100%;
	line-height: 24px;
}

li.v-leasing-form-result__item .v-leasing-form-result__noresult {
	display: flex;
}

.v-leasing-form-result__noresult > p {
	text-align: center;
}
</style>
